import React, {useContext, useEffect, useState} from "react";
import TreeContainer from "../../../components/tree/TreeContainer";
import {TranslateContext} from "../../../context/TranslateContext";
import {MobileContext} from "../../../context/MobileContext";
import {
    deleteStrutturaClasseMacrocategoriaApi,
    getStrutturaClassiMacrocategorieApi
} from "../services/MacrocategorieServices";
import ConfStrutturaClassiMacrocategorieView from "./ConfStrutturaClassiMacrocategorieView";

export default function ConfStrutturaClassiMacrocategorieController() {

    const [loadingData, setLoadingData] = useState(true);

    const [data, setStrutture] = useState([]);
    const [albero, setAlbero] = useState([]);
    const [strMacrSel, setStrMacrSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);
    const {isMobile} = useContext(MobileContext);

    async function getStrutturaClassiMacrocategorie() {
        const response = await getStrutturaClassiMacrocategorieApi();
        setStrutture(response.data.data?.lista);
        setAlbero(response.data.data?.albero);
        setLoadingData(false);
    }

    useEffect(() => {
        if (loadingData) {
            getStrutturaClassiMacrocategorie();
        }
    }, []);

    const eliminaStrClasse = async () => {
        setShowConfirm(false);
        const response = await deleteStrutturaClasseMacrocategoriaApi(strMacrSel.id_struttura_classe_macrocategoria);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setStrutture(response.data.data?.lista);
            setAlbero(response.data.data?.albero);
        }
    }

    function getAlberoStruttura() {
        return (
            <TreeContainer
                data={albero}
                idSelected={''}
                onClickItem={() => {
                }}
                getLabel={(elemento) => elemento.descrizione}
                getFigli={(elemento) => elemento.figli}
                icona={(elemento) => <i className={elemento.icona}/>}
            />
        );
    }

    function onClickElimina(row) {
        setStrMacrSel(row)
        setShowConfirm(true);
    }

    return (
        !loadingData &&
        <ConfStrutturaClassiMacrocategorieView
            showConfirm={showConfirm}
            loadingData={loadingData}
            setShow={setShow}
            setShowConfirm={setShowConfirm}
            show={show}
            translate={translate}
            data={data}
            getAlberoStruttura={getAlberoStruttura}
            modalMsg={modalMsg}
            eliminaStrClasse={eliminaStrClasse}
            isMobile={isMobile}
            strMacrSel={strMacrSel}
            onClickElimina={onClickElimina}
        />
    );
}